// const logoObserver = new IntersectionObserver((entries) => {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//     entry.target.classList.add('show-logo');
//     } else {
//       entry.target.classList.remove('show-logo');
//     }
//   });
// }, {threshold: 0.1});

// const logoElements = document.querySelector('.car-logos-container');
// logoObserver.observe(logoElements);

const logoObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const childLogos = entry.target.querySelectorAll("a")
      childLogos.forEach((child) => {
        child.classList.add('show-logo');
      });
    } else {
      const childLogos = entry.target.querySelectorAll("a")
      childLogos.forEach((child) => {
        // child.classList.remove('show-logo');
      })
    }
  });
}, {threshold: 0.1});

const logoElements = document.querySelector('.car-logos-container');
logoObserver.observe(logoElements);